// @flow
import { APICore } from "./apiCore";

const api = new APICore();

function ApiGetAllFasilitas(params: any): any {
  const baseUrl = "/api/admin/fasilitas";
  return api.get(`${baseUrl}`, params);
}

function ApiGetReportFasilitas(params: any): any {
  const baseUrl = "/api/admin/fasilitas_order/report";
  return api.get(`${baseUrl}`, params);
}

function ApiGetReportTerapisFasilitas(params: any): any {
  const baseUrl = "/api/admin/transaksireflexy/feefasilitas";
  return api.get(`${baseUrl}`, params);
}

function ApiPrintFasilitas(params: any): any {
  const baseUrl = "/api/admin/fasilitas_order/report/pdf";
  return api.getFile(`${baseUrl}`, params);
}
function ApiPrintExcelFasilitas(params: any): any {
  const baseUrl = "/api/admin/fasilitas_order/report/excel";
  return api.getFile(`${baseUrl}`, params);
}

function ApiPostFasilitas(params: any): any {
  const baseUrl = "/api/admin/fasilitas";
  return api.create(`${baseUrl}`, params);
}
function ApiEditFasilitas(params: any, id: any): any {
  const baseUrl = "/api/admin/fasilitas/" + id;
  return api.update(`${baseUrl}`, params);
}
function ApiDeleteFasilitas(id: any): any {
  const baseUrl = "/api/admin/fasilitas/" + id;
  return api.delete(`${baseUrl}`);
}

export {
  ApiGetAllFasilitas,
  ApiGetReportFasilitas,
  ApiGetReportTerapisFasilitas,
  ApiPostFasilitas,
  ApiEditFasilitas,
  ApiPrintFasilitas,
  ApiPrintExcelFasilitas,
  ApiDeleteFasilitas,
};
